export enum UserProfession {
  ANALYST = 'Analyst',
  DATA_ENGINEER = 'Data Engineer',
  DATA_SCIENTIST = 'Data Scientist',
  PLATFORM_ENGINEER = 'Platform Engineer',
  MANAGER = 'Manager',
  OTHER = 'Other'
}

export enum UserIndustry {
  FINANCE = 'Finance',
  HEALTHCARE = 'Healthcare',
  MANUFACTURING = 'Manufacturing',
  ENERGY = 'Energy',
  TRANSPORTATION = 'Transportation',
  RETAIL = 'Retail',
  HOSPITALITY = 'Hospitality',
  OTHER = 'Other'
}

export type UserIndustryType = keyof typeof UserIndustry;

export const PROFESSIONS = Object.values(UserProfession);
export const INDUSTRIES = Object.values(UserIndustry);
